import { EState } from "src/app/dashboard/modules/current-agent-states/current-agent-states.models";

// These interfaces are to be used for Agent List Details / Agent Zoom
export interface SummaryState {
    loggedOut: SummaryStateItem;
    available: SummaryStateItem;
    availableDialer: SummaryStateItem;
    workingContacts: SummaryStateItem;
    workingContactsDialer: SummaryStateItem;
    totalUnavailable: SummaryStateItem;
    unavailableStates: SummaryStateItem[];
    summaryTotal: SummaryStateItem;
}

export interface SummaryStateItem {
    durationString: string;
    durationSeconds: number;
    percentage: number;
    stateName: string;
}

export enum AgentStateBuckets {
    LoggedOut = 8,
    Available = 12,
    WorkingContacts = 13,
    Unavailable = 2
}

// The following interfaces map backend response data models
export interface AgentState {
    State: EState;
    AgentStateBucket: AgentStateBuckets;
    DisplayState: string;
    IsACW: boolean;
    IsDialer: boolean;
}

export interface SingleAgentState {
    GroupID: number;
    GroupName: string;
    CurrentState: AgentState;
    Duration: string; // On single state this is returned as a timestamp "HH:MM:SS"
    StateStartTime: string; // ISO String
    UserID: string;
    AgentSessionID: string;
}

export interface AgentStateDetails {
    SkillNo: number;
    CampaignNo: number;
    AgentSessionID: string;
    AgentNo: number;
    TeamNo: number;
    UserId: string;
    EmpGroup1ID: number;
    DtAgentSessionStartTimestamp: string;
    AgentStateNo: number;
    Dialer: boolean;
    DtAgentSessionActivityStartTimestamp: string;
    ActivityStartTimeDisplay: string;
    AgentStateBucketID: string;
    AgentStateBucketName: string;
    DisplayStateName: string;
    Duration: number;
}

export interface SingleAgentStates {
    Details: AgentStateDetails[];
    ImagePath: string;
    AgentStateCategories: { [key: string]: string };
    LastUpdatedDateTime: string;
}
